import { Routes, Route } from 'react-router-dom';
import RouteComponent from './../components/routes/RouteComponent';

export default function ContainerComponent({ navRoutes, status, highlights, contentData, error, loader }) {
    return (
        <Routes>
            {
                navRoutes.map((item, index) => {
                    return (item.isActive === "True" &&
                        <Route key={index} path={item.route} Component={() => <RouteComponent page={item.route} status={status} welcome={highlights} contentData={contentData} error={error} loader={loader}/>} />
                    )
                })
            }
            <Route path="*" Component={() => <RouteComponent page="*" status={status} welcome={highlights} contentData={contentData} error={error} loader={loader}/>} />
        </Routes>
    )
}
